<template>
  <div class="budget-body">
    <div class="budget-value budget-max"><span v-if="value[1] >= 2000">+</span><span>€</span> {{localize(1)}}</div>
    <vue-slider
      :value="value"
      @change="onChange"
      :min="400"
      :max="2000"
      :enable-cross="false"
    ></vue-slider>
    <div class="budget-value budget-min"><span>€</span> {{localize(0)}}</div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';

export default {
  components: {VueSlider},

  props: ['value'],

  methods: {
    onChange(value) {
      this.$emit('input', value);
    },

    localize(index) {
      return this.value[index].toLocaleString();
    },
  }
};
</script>
